<template>
<div class="chapter">
<div class="inner_page">
<h1 class="center" id="title_page" style="margin-top:80px;">The Blue Herring Mystery</h1>
<h3 class="center" style="margin-top:60px;">Ellery Queen Jr.</h3>
<p class="center" style="margin-top:80px;"><img alt="logo" src="OEBPS/images/logo.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?2103e6da